import { useCallback, useEffect, useState } from 'react'

function useWindowFocus() {
  const [hasFocus, setHasFocus] = useState(document.hasFocus())

  const handleFocus = useCallback(() => {
    setHasFocus(true)
  }, [])

  const handleBlur = useCallback(() => {
    setHasFocus(false)
  }, [])

  useEffect(() => {
    window.addEventListener('focus', handleFocus)
    window.addEventListener('blur', handleBlur)

    return () => {
      window.removeEventListener('focus', handleFocus)
      window.removeEventListener('blur', handleBlur)
    }
  }, [handleFocus, handleBlur])

  return {
    hasFocus,
  }
}

export default {
  useWindowFocus,
}
